import {fetch} from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryRoles(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/roles`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryRole(sysRoleId) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/roles/${ sysRoleId }`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  name
 * @param  description
 * @param  isActive
 * @param menuIds
 * @param code
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addRole(
  {
    name,
    description,
    isActive,
    menuIds,
    code
  },
) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/roles`,
    method: 'post',
    data: {
      name,
      description,
      isActive,
      menuIds,
      code
    },
  });
}

/**
 * 更新
 * @param sysRoleId
 * @param  id
 * @param  name
 * @param  description
 * @param  isActive
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateRole(sysRoleId, {
  name,
  description,
  isActive,
  menuIds,
  code
}) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/roles/${ sysRoleId }`,
    method: 'patch',
    data: {
      name,
      description,
      isActive,
      menuIds,
      code
    },
  });
}

/**
 * 删除
 * @param sysRoleId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteRole(sysRoleId) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/roles/${ sysRoleId }`,
    method: 'delete',
  });
}

export default {};
